/**
 * Created by JIocb on 24.05.2017.
 */
namespace Factive.Game {
    import DisplayObject = PIXI.DisplayObject;
    import DependenciesContainer = Factive.Core.DependenciesContainer;
    import PanelManager = Factive.Core.PanelManager;
    import DialogColorBonusPanel = Factive.Core.DialogColorBonusPanel;
    import AchievementPanel = Factive.Core.AchievementPanel;
    import HelpPanel = Factive.Core.HelpPanel;
    import EventBus = Factive.Core.EventBus;

    import EventBusConstants = Factive.Core.EventBusConstants;
    import LocalizationManager = Arkadium.Core.utils.LocalizationManager;
    import InteractionEvent = PIXI.interaction.InteractionEvent;
    import StorageManager = Factive.Core.StorageManager;
    import StorageManagerConstants = Factive.Core.StorageManagerConstants;
    import ISoundManager = Factive.Core.ISoundManager;
    import ArenaHelper = Arkadium.Game.ArenaHelper;
    import GameEndPanel = Factive.Core.GameEndPanel;
    import AreYouSurePanel = Factive.Core.AreYouSurePanel;
    import PanelSupervisor = Factive.Core.PanelSupervisor;
    import DiceResultInterface = Factive.Game.DiceResultInterface;
    import AnalyticsConstants = Factive.Game.AnalyticsConstants;

    export class GameRoom {
        private _gameMain: GameMain;
        private _container: PIXI.Container;
        private _sceneArmature: dragonBones.Armature;
        private _lm: LocalizationManager;
        private _pm: PanelManager;
        private _dc: DependenciesContainer;
        private _diceBox: DiceRollingBox = null;
        private _tableView: ScoreTableView;
        private _userBagView: UserBagView;
        private _gameRoomModel: Factive.Game.GameRoomModel;
        private _eb: EventBus;
        private _arenaHelper: ArenaHelper;
        private _sm: ISoundManager;
        private _message: PIXI.Text;
        private _assetScale: number;
        private _startGameTimeMs: number;
        private _controls: ControlsView;
        private _panelSupervisor: PanelSupervisor;
        private _aspectRatio: string = null;

        public constructor(dependenciesContainer: DependenciesContainer, container: PIXI.Container, gameMain:GameMain) {
            this._container = container;
            this._dc = dependenciesContainer;
            this._gameMain = gameMain;
            this._lm = this._dc.get("LocalizationManager");
            this._pm = this._dc.get("PanelManager");
            this._eb = this._dc.get("EventBus");
            this._arenaHelper = this._dc.get("ArenaHelper");
            this._sm = this._dc.get("SoundManager");
            this._assetScale = this._dc.get("AssetScale");
        };

        private returnDataForGameEnd(): any
        {
            return {score:this._gameRoomModel.totalScore};
        }
        private callMidroll(): void {
            //this._arenaHelper.sendMidrollRequest();
        }

        private callRefresh(): void {
            this._arenaHelper.sendEventChange();
        }

        public initialize()
        {
            this._startGameTimeMs = window.performance.now();

            this._gameRoomModel = new GameRoomModel();
            this._gameRoomModel.signal.add(this.handleEventsFromModel, this);

            this._diceBox = new DiceRollingBox(this._dc,this._aspectRatio,this._gameRoomModel.getUserBagModel());

            this._panelSupervisor = new PanelSupervisor(this._dc, this);
            this._panelSupervisor.setGameEndDataCreationFunction(this.returnDataForGameEnd,this);
            this._panelSupervisor.initialize();

            this._eb.add(EventBusConstants.GAMEPLAY_MIDROLL_STARTED, EventBusConstants.GAMEPLAY, this.handleMidrollStarted, this);
            this._eb.add(EventBusConstants.GAMEPLAY_MIDROLL_FINISHED, EventBusConstants.GAMEPLAY, this.handleMidrollFinished, this);
        };

        public startNewGame(){
            this._arenaHelper.sendGameStart();
            this._eb.dispatch(AnalyticsConstants.ACTION_START, AnalyticsConstants.TOPIC_ANALYTIC);

            this._sm.stopSound(SoundConstants.BG_MUSIC);
            this._sm.playSound(SoundConstants.BG_MUSIC, true, 0.5);
        }


        public changeAspectRatio(aspectRatio: string): void {
            if (this._aspectRatio != aspectRatio)
            {
                this._aspectRatio = aspectRatio;
                this.applyAspectRatio(this._aspectRatio);
            }
        }

        private applyAspectRatio(aspectRatio:string)
        {
            this.reset();

            if(aspectRatio == "landscape")
            {
                this._diceBox.x = -124 * this._assetScale;
                this._diceBox.y = -18 * this._assetScale;

                this._sceneArmature = dragonBones.PixiFactory.factory.buildArmature("A_LandscapeScene");
            }else if(aspectRatio == "portrait")
            {
                this._diceBox.x = 10 * this._assetScale;
                this._diceBox.y = 50 * this._assetScale;

                this._sceneArmature = dragonBones.PixiFactory.factory.buildArmature("A_PortraitScene");
            }
            this._diceBox.applyAspectRatio(aspectRatio);

            this._controls = new ControlsView(this._dc);
            this._container.addChild(this._sceneArmature.display as DisplayObject);
            dragonBones.WorldClock.clock.add(this._sceneArmature);
            this._container.addChild(this._diceBox);

            this._controls.initialize(this._sceneArmature,aspectRatio);
            this._controls.signal.add(this.handleControlsViewEvent, this);

            this._tableView = new ScoreTableView(this._sceneArmature.getSlot("ResultTable").childArmature, this._gameRoomModel.getScoreTableModel(), this._dc, this._container,aspectRatio);
            this._tableView.signal.add(this.handleTableViewEvents, this);

            this._userBagView = new UserBagView(this._sceneArmature.getSlot("WoodenPanel"), this._gameRoomModel.getUserBagModel());
            this._userBagView.signal.add(this.handleBagViewEvents, this);

            this.updateUIControls();

            this._message = new PIXI.Text("", <PIXI.TextStyle>{
                fontFamily: 'Medium',
                fontSize: ((this._aspectRatio == "landscape")? 12:16) * this._assetScale,
                fill: '#FFFFFF',
                align: "center"
            });

            this._message.anchor.set(.5, .5);
            //this._message.scale.x = this._message.scale.y = .5;

            var wp = this._sceneArmature.getSlot("WoodenPanel").display;
            this._message.x = wp.x;
            this._message.y = wp.y - wp.height * .6;
            //this._message.anchor.set(0,.5);
            this._container.addChild(this._message);
            this.showMessage(this._lm.getText("msg_roll"));
        };

        public reset(): void
        {
            if(this._sceneArmature)
            {
                dragonBones.WorldClock.clock.remove(this._sceneArmature);
                this._container.removeChild(this._sceneArmature.display as DisplayObject);
                this._sceneArmature = null;
            }

            if(this._controls)
            {
                this._controls.signal.remove(this.handleControlsViewEvent, this);
                this._controls.destroy();
                this._controls = null;
            }
            if(this._tableView)
            {
                this._tableView.signal.remove(this.handleTableViewEvents, this);
                this._tableView.destroy();
                this._tableView = null;
            }
            if(this._userBagView)
            {
                this._userBagView.signal.remove(this.handleBagViewEvents, this);
                this._userBagView.destroy();
                this._userBagView = null;
            }
            if(this._message)
            {
                this._container.removeChild(this._message);
                this._message = null;
            }
        };

        protected handleControlsViewEvent(evt: string, data?: any): void {

            switch (evt) {
                case "press_sound_on": {
                    this._eb.dispatch(AnalyticsConstants.ACTION_SOUND_ON_CLICK, AnalyticsConstants.TOPIC_ANALYTIC);
                    this.callRefresh();
                    break;
                }
                case "press_sound_off": {
                    this._eb.dispatch(AnalyticsConstants.ACTION_SOUND_OFF_CLICK, AnalyticsConstants.TOPIC_ANALYTIC);
                    this.callRefresh();
                    break;
                }
                case "press_help": {
                    this._panelSupervisor.openPanel(PanelName.Help, null);
                    this.callRefresh();
                    break;
                }
                case "press_quit": {
                    this._panelSupervisor.openPanel(PanelName.AreYouSureQuit, {score: this._gameRoomModel.totalScore, numberOfTotalRolls:this._gameRoomModel.numberOfTotalRolls});

                    this.callRefresh();
                    break;
                }
                case "press_undo": {
                    this._eb.dispatch(AnalyticsConstants.ACTION_UNDO, AnalyticsConstants.TOPIC_ANALYTIC);
                    this._gameRoomModel.undo();
                    this.callRefresh();
                    break;
                }
                case "press_roll": {
                    this.handlePress();
                    break;
                }
                case "press_settings": {
                    this._panelSupervisor.openPanel(PanelName.Settings,null);
                    break;
                }
            }
        }

        protected showMessage(msg: string): void {
            this._message.text = msg;
        }

        protected handleTableViewEvents(evt, data): void {
            switch (evt) {
                case "select_combination": {

                    var ids: Array<number> = this._gameRoomModel.getUserBagModel().getBagDicesIds();

                    this._diceBox.hideDicesExceptIds(ids);

                    this._gameRoomModel.saveScore(data.id, data.multiplier);

                    this.showMessage(this._lm.getText("msg_roll"));

                    break;
                }
            }
        };

        protected handleBagViewEvents(evt, data): void {

            if (evt == "press_on_dice") {
                var dice = data.dice;

                let sm:ISoundManager = <ISoundManager>this._dc.get("SoundManager");
                sm.playSound(SoundConstants.BUTTON_CLICK);

                this._diceBox.showDice(dice);
                this.updateUIControls();
            }
        }

        protected handleBoxEvents(evt, data): void {
            switch (evt) {
                case DiceRollingBoxEventType.DICE_SELECTED: {
                    var dice: DiceData = data.dice;
                    this._gameRoomModel.addDiceToBag(dice);
                    this.updateUIControls();

                    let sm:ISoundManager = <ISoundManager>this._dc.get("SoundManager");
                    sm.playSound(SoundConstants.BUTTON_CLICK);

                    break;
                };
                case DiceRollingBoxEventType.ROLL_COMPLETE: {
                    var result = data.result;

                    this.sendAnalytic5roll(result);

                    if(this._gameRoomModel.numRollsLeft == 2){
                        this.callMidroll();
                        this.callRefresh();
                    }

                    if (this._gameRoomModel.isBonusMode) {
                        this._gameRoomModel.finishBonusMode(result[0].value);
                        this.updateUIControls();
                    }
                    else {
                        this._gameRoomModel.finishRoll(result);
                        if (this._gameRoomModel.numRollsLeft > 0) {
                            this._controls.rollEnableInput(true);
                        }
                    }

                    this.showMessage(this._lm.getText(this._gameRoomModel.numRollsLeft > 0 ? "msg_select" : "msg_score"));

                    this._gameRoomModel.lockScoreTableInput(false);
                    break;
                };
                case DiceRollingBoxEventType.COLOR_BONUS: {
                    this._eb.dispatch(AnalyticsConstants.ACTION_COLOR, AnalyticsConstants.TOPIC_ANALYTIC);

                    let eventName: string = "";
                    let diceResult: DiceResultInterface = data.dice;

                    switch (diceResult.value)
                    {
                        case 1:{
                            eventName = AnalyticsConstants.ACTION_COLOR_1;
                            break;
                        };
                        case 2:{
                            eventName = AnalyticsConstants.ACTION_COLOR_2;
                            break;
                        };
                        case 3:
                        {
                            eventName = AnalyticsConstants.ACTION_COLOR_3;
                            break;
                        };
                    }
                    if(eventName != "")
                    {
                        this._eb.dispatch(eventName, AnalyticsConstants.TOPIC_ANALYTIC);
                    }
                    break;
                };
            }
        };

        public sendAnalytic5roll(result:Array<DiceData>):void
        {
            let targetValue:number = -1;
            let isSend:boolean = true;

            for(let i:number = 0; i < result.length; i++)
            {
                let diceData:DiceData = result[i];
                if(targetValue < 0)
                {
                    targetValue = diceData.value;
                }
                else
                {
                    if(targetValue != diceData.value)
                    {
                        isSend = false;
                        break;
                    }
                }
            }

            if(isSend)
            {
                this._eb.dispatch(AnalyticsConstants.ACTION_5_ROLL, AnalyticsConstants.TOPIC_ANALYTIC);
            }
        }

        private handleEventsFromModel(evt: any, data: any): void {
            switch (evt) {
                case "game_end": {
                    this._eb.dispatch(AnalyticsConstants.ACTION_TOTAL_ROLLS, AnalyticsConstants.TOPIC_ANALYTIC, {value:this._gameRoomModel.numberOfTotalRolls});

                    var delaySec:number = Math.floor((window.performance.now() - this._startGameTimeMs) / 1000);
                    this._eb.dispatch(AnalyticsConstants.ACTION_TIME_WIN, AnalyticsConstants.TOPIC_ANALYTIC, {seconds:delaySec});

                    this._panelSupervisor.openPanel(PanelName.GameEnd, {score: this._gameRoomModel.totalScore});
                    break;
                };

                case "rolled": {
                    let lastSelectedScore:number = this._gameRoomModel.getScoreTableModel().lastSelectedScore;
                    if(lastSelectedScore == 0)
                    {
                        this._eb.dispatch(AnalyticsConstants.ACTION_ZERO, AnalyticsConstants.TOPIC_ANALYTIC);
                    }

                    this._arenaHelper.changeScore(this._gameRoomModel.totalScore);
                    this.updateUIControls();
                    break;
                };

                case "round_finished": {
                    this.updateUIControls();
                    break;
                };

                case "round_undoed": {
                    var ids: Array<number> = this._gameRoomModel.getUserBagModel().getBagDicesIds();
                    this._diceBox.showDicesExceptIds(ids);

                    this.showMessage(this._lm.getText("msg_score"));

                    this.updateUIControls();
                    break;
                };
                case "new_achievement": {
                    this.sendAnalyticActionScore(data.score);
                    this._panelSupervisor.openPanel(PanelName.Achievement, {score: data.score, stars: data.stars});
                    break;
                };
                case "color_bonus_available": {
                    this._eb.add(EventBusConstants.GAMEPLAY_ACTIVATE_COLOR_BONUS, EventBusConstants.GAMEPLAY, this.handleActivateColorBonus, this);

                    this.sdfsdf_ids = this._gameRoomModel.getUserBagModel().getBagDicesIds();
                    this._diceBox.hideDicesExceptIds(this.sdfsdf_ids);
                    this._gameRoomModel.showAllDicesInBug();

                    this._panelSupervisor.openPanel(PanelName.DialogColorBonus);
                    break;
                };
            }
        };

        private sendAnalyticActionScore(score: number): void {
            let eventName:string = score > 2500 ? AnalyticsConstants.ACTION_SCORE_MORE_2500 : "";
            switch (score)
            {
                case 500:
                {
                    eventName = AnalyticsConstants.ACTION_SCORE_500;
                    break;
                }
                case 1000:
                {
                    eventName = AnalyticsConstants.ACTION_SCORE_1000;
                    break;
                }
                case 1500:
                {
                    eventName = AnalyticsConstants.ACTION_SCORE_1500;
                    break;
                }
                case 2000:
                {
                    eventName = AnalyticsConstants.ACTION_SCORE_2000;
                    break;
                }
                case 2500:
                {
                    eventName = AnalyticsConstants.ACTION_SCORE_2500;
                    break;
                }
            }
            if(eventName != "")
            {
                this._eb.dispatch(eventName, AnalyticsConstants.TOPIC_ANALYTIC, {score:score});
            }
        }

        private sdfsdf_ids: Array<number>;

        private handleActivateColorBonus(evt: any): void {
            this._eb.remove(EventBusConstants.GAMEPLAY_ACTIVATE_COLOR_BONUS, EventBusConstants.GAMEPLAY, this.handleActivateColorBonus, this);

            this._gameRoomModel.unshowAllDicesInBug();
            this._diceBox.showDicesExceptIds(this.sdfsdf_ids);

            if (evt.data.result == true) {
                this._gameRoomModel.activateBonusMode();
                this._diceBox.hideDicesExceptIds(null);

                this._gameRoomModel.lockScoreTableInput(true);
                this.updateUIControls();
                this.handlePress();
            }
        }

        public getNumRollsLeft():number{
            return this._gameRoomModel.numRollsLeft;
        }

        private updateUIControls(): void {
            this._controls.undoEnableInput(this._gameRoomModel.isUndoAvailable());

            var cnt: number = this._gameRoomModel.numRollsLeft;

            if (this._gameRoomModel.isBonusMode) {
                this._controls.rollEnableInput(false && this._diceBox.isResting);
                this._controls.rollAddLabel(this._lm.getText("no_roll"));
            }
            else {
                if (cnt > 0 && this._gameRoomModel.getBagLength() < 5) {
                    this._controls.rollEnableInput(true && this._diceBox.isResting);
                    this._controls.rollAddLabel(this._lm.getText("rollx").replace("{N}",cnt.toString()));
                }
                else {
                    this._controls.rollEnableInput(false && this._diceBox.isResting);
                    this._controls.rollAddLabel(this._lm.getText("no_roll"));
                }
            }
        };

        protected handlePress(): void {
            this._gameRoomModel.lockScoreTableInput(true);
            this._controls.rollEnableInput(false);
            this._diceBox.signal.add(this.handleBoxEvents, this);

            if (this._gameRoomModel.isBonusMode) {
                this._diceBox.bonusRoll();
            }
            else {

                this._diceBox.regularRoll();
            }
            this.showMessage("");
            this._gameRoomModel.roll();
        };

        public resize(width: number, height: number) {

        }

        public handleMidrollStarted(data: any): void {
            this._sm.mute(true);
        }

        public handleMidrollFinished(data: any): void {
            var ls: StorageManager = <StorageManager>this._dc.get("StorageManager");
            var mute: boolean = ls.loadData(StorageManagerConstants.MUTE_SOUNDS) == "1";
            this._sm.mute(mute);

        }

        public restart(): void {
            this._gameMain.restart();
        }

        public destroy(): void {
            this._controls.destroy();
            this._controls = null;

            this._panelSupervisor.destroy();
            this._panelSupervisor = null;

            this._container.removeChild(this._message);
            this._message = null;
            this._lm = null;
            this._dc = null;
            this._eb.remove(EventBusConstants.GAMEPLAY_MIDROLL_STARTED, EventBusConstants.GAMEPLAY, this.handleMidrollStarted, this);
            this._eb.remove(EventBusConstants.GAMEPLAY_MIDROLL_FINISHED, EventBusConstants.GAMEPLAY, this.handleMidrollFinished, this);
            this._eb.remove(EventBusConstants.GAMEPLAY_ACTIVATE_COLOR_BONUS, EventBusConstants.GAMEPLAY, this.handleActivateColorBonus, this);
            this._eb = null;

            this._container.removeChildren();
            this._container = null;
            this._sceneArmature = null;

            this._lm = null;
            this._pm = null;
            this._dc = null;
            this._diceBox.destroy();

            this._tableView.destroy();
            this._tableView = null;

            this._userBagView.destroy();
            this._userBagView = null;

            this._gameRoomModel.destroy();
            this._gameRoomModel = null;

            this._arenaHelper.destroy();
            this._arenaHelper = null;

            //this._sm.destroy();
            this._sm = null;

            this._gameMain = null;
        }
    }
};



// WEBPACK FOOTER //
// src/typescript/Game/Engine/GameRoom.ts